const RadioStyles = {
  // Can simply pass default props to change default behaviour of components.
  defaultProps: {
    variant: "primary",
    textFlip: false,
  },
  baseStyle: ({ colorScheme }: { colorScheme: string }) => ({
    borderColor: `${colorScheme}.300`,
    bg: "transparent",
    _text: {
      color: `neutrals.950`,
    },
    _icon: {
      color: colorScheme === "primary" ? `${colorScheme}.900` : "neutrals.900",
    },
    _checked: {
      borderColor: `${colorScheme}.300`,
      borderWidth: "2",
    },
  }),
};

export default RadioStyles;
